import { useQuery } from 'data-fetching-client';
import ThemeDetailsResponse from 'marketplace-ui-assets-core/details/records/ThemeDetailsResponse';
import { useUnifiedDetails } from 'marketplace-ui-details/hooks/useUnifiedDetails';
import { useMemo } from 'react';
import { GET_THEME_DETAILS } from '../queries/themeDetailsQuery';
export function useThemeDetails({
  isUngatedForUnifiedDetails,
  slug
}) {
  // We can't use the Unified Details CHIRP endpoint in the public marketplace.
  // Because we're rolling it out behind a gate, and a public user will always be
  // !isUngatedForUnifiedDetails, this logic still works, but if we remove the gate,
  // we'll need to account for public users.
  const {
    unifiedDetailsData,
    unifiedDetailsLoading,
    unifiedDetailsError,
    previousUnifiedDetailsData
  } = useUnifiedDetails({
    slug,
    skip: !isUngatedForUnifiedDetails
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_THEME_DETAILS, {
    variables: {
      slug
    },
    skip: isUngatedForUnifiedDetails
  });
  const themeDetails = useMemo(() => {
    let themeDetailsData;
    if (isUngatedForUnifiedDetails) {
      themeDetailsData = unifiedDetailsData || previousUnifiedDetailsData;
      return new ThemeDetailsResponse(themeDetailsData);
    } else {
      themeDetailsData = data || previousData;
      return new ThemeDetailsResponse(themeDetailsData ? themeDetailsData.details : undefined);
    }
  }, [data, previousData, unifiedDetailsData, previousUnifiedDetailsData, isUngatedForUnifiedDetails]);
  return {
    loading: isUngatedForUnifiedDetails ? unifiedDetailsLoading : loading,
    error: isUngatedForUnifiedDetails ? unifiedDetailsError : error,
    themeDetails
  };
}